import { mixpanelObject } from 'src/utils/analytics';
import {
  getGuestUserPaymentTransactionId,
  getPaymentLinkStatus,
  getTempUserTransactionId,
  isGuestUserPaymentSuccess
} from 'src/utils/ConsumptionHelper/BuyPlanHelper';

import {
  MIXPANEL_ACTIVE_SUBSCRIPTION_FOUND_POPUP,
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_CONSUMPTION_SUBSCRIPTION,
  MIXPANEL_CTA,
  MIXPANEL_ELEMENT,
  MIXPANEL_INTIAL_LANDING,
  MIXPANEL_IS_SUBSCRIPTION_FLOW,
  MIXPANEL_MANDATORY_REGISTRATION,
  MIXPANEL_MANUAL_MOBILE,
  MIXPANEL_METHOD,
  MIXPANEL_NATIVE,
  MIXPANEL_PAYMENT_NOT_LINKED_POPUP,
  MIXPANEL_PAYMENT_SUCCESSFUL_POPUP,
  MIXPANEL_POP_UP_GROUP,
  MIXPANEL_POP_UP_NAME,
  MIXPANEL_POP_UP_TYPE,
  MIXPANEL_SUCCESS,
  MIXPANEL_TRY_AGAIN_WITH_OTP,
  MIXPANEL_VERIFY_MOBILE_OTP,
  MIXPANEL_VERIFY_OTP,
  MIXPANEL_VERIFY_YOUR_ACCOUNT
} from '../../utils/analytics/mixpanel/mixpanelConstants';
import {
  popupCTAEvent,
  interimSubscriptionPaymentSuccess,
  popupLaunchEvent
} from '../../utils/analytics/mixpanel/mixpanelEventsHelper';

const paymentSuccess = isGuestUserPaymentSuccess();
const orderId =
  getGuestUserPaymentTransactionId() || getTempUserTransactionId();
const paymentNotLinked = getPaymentLinkStatus();

const getPopupName = (isActiveSubscriptionFound?: boolean) => {
  let name = '';
  if (paymentSuccess && orderId) {
    if (paymentNotLinked) {
      name = MIXPANEL_PAYMENT_NOT_LINKED_POPUP;
    } else if (isActiveSubscriptionFound) {
      name = MIXPANEL_ACTIVE_SUBSCRIPTION_FOUND_POPUP;
    } else {
      name = MIXPANEL_PAYMENT_SUCCESSFUL_POPUP;
    }
  }
  return name;
};

export const sendOtpPopupCtaEvent = (isActiveSubscriptionFound?: boolean) => {
  if (paymentSuccess && orderId) {
    mixpanelObject.setProperty(
      MIXPANEL_POP_UP_NAME,
      getPopupName(isActiveSubscriptionFound)
    );
    mixpanelObject.setProperty(
      MIXPANEL_POP_UP_GROUP,
      MIXPANEL_CONSUMPTION_SUBSCRIPTION
    );
    mixpanelObject.setProperty(MIXPANEL_POP_UP_TYPE, MIXPANEL_NATIVE);
  }
  mixpanelObject.setProperty(MIXPANEL_BUTTON_TYPE, MIXPANEL_CTA);
  popupCTAEvent();
};

export const userOnboarPopupLaunchEvent = (
  isActiveSubscriptionFound?: boolean
) => {
  // popup launch event for active subscription found popup - as it is just state change & not render - it's not triggered in DrowerPopup
  mixpanelObject.setProperty(
    MIXPANEL_POP_UP_NAME,
    getPopupName(isActiveSubscriptionFound)
  );
  mixpanelObject.setProperty(MIXPANEL_POP_UP_TYPE, MIXPANEL_NATIVE);
  mixpanelObject.setProperty(
    MIXPANEL_POP_UP_GROUP,
    MIXPANEL_CONSUMPTION_SUBSCRIPTION
  );
  mixpanelObject.setProperty(MIXPANEL_IS_SUBSCRIPTION_FLOW, true);
  popupLaunchEvent();
};

export const interimSubscriptionPaymentSuccessEvent = () => {
  mixpanelObject.setProperty(
    MIXPANEL_POP_UP_GROUP,
    MIXPANEL_CONSUMPTION_SUBSCRIPTION
  );
  mixpanelObject.setProperty(
    MIXPANEL_POP_UP_NAME,
    MIXPANEL_PAYMENT_SUCCESSFUL_POPUP
  );
  mixpanelObject.setProperty(MIXPANEL_SUCCESS, true);
  interimSubscriptionPaymentSuccess();
};

export const OtpPopupCtaEvent = (isResend?: boolean) => {
  mixpanelObject.setProperty(
    MIXPANEL_POP_UP_NAME,
    isResend ? MIXPANEL_VERIFY_YOUR_ACCOUNT : MIXPANEL_VERIFY_MOBILE_OTP
  );
  mixpanelObject.setProperty(
    MIXPANEL_ELEMENT,
    isResend ? MIXPANEL_TRY_AGAIN_WITH_OTP : MIXPANEL_VERIFY_OTP
  );
  mixpanelObject.setProperty(MIXPANEL_POP_UP_TYPE, MIXPANEL_INTIAL_LANDING);
  mixpanelObject.setProperty(
    MIXPANEL_POP_UP_GROUP,
    MIXPANEL_MANDATORY_REGISTRATION
  );
  mixpanelObject.setProperty(MIXPANEL_METHOD, MIXPANEL_MANUAL_MOBILE);
  mixpanelObject.setProperty(MIXPANEL_BUTTON_TYPE, MIXPANEL_CTA);
  popupCTAEvent();
};
